module.exports = __webpack_public_path__ + "static/media/add.3e5ed604.svg";